import Vue from "vue"
import Router from 'vue-router'

import Login from '@/page/login.vue'
import Page404 from '@/page/404.vue'
//订单
import orderList from '@/page/order/orderList'
import addOrder from '@/page/order/addOrder'
//库存
import repertoryList from '@/page/repertory/repertoryList'
import goOutList from '@/page/repertory/goOutList'
//货运
import priceContort from '@/page/freightage/priceContort'
import houserAddress from '@/page/freightage/houserAddress'
//人员
import adminList from '@/page/personnel/adminList'
import customerList from '@/page/personnel/customerList'

//协议设置
import Agree from '@/page/system/agree.vue'
import Notice from '@/page/system/notice.vue'

//发单列表
import dispathchList from '@/page/order/dispatchList.vue'

import deliverDispathchList from '@/page/delivery/dispatchList.vue'
//工单
import workOrderList from '@/page/workOrder/workOrderList'
import workOrderRemark from '@/page/workOrder/workOrderRemark'
//货物价格
import priceGoods from '@/page/freightage/priceGoods'

import checkExpress from '@/page/order/checkExpress'

import deliveryList from '@/page/delivery/list'
import transportList from '@/page/transport/list'
import deliveryOrder from '@/page/delivery/order'
import deliveryOrderList from '@/page/delivery/orderList'
// import deliveryBook from '@/page/delivery/book'
import deliveryForm from '@/page/delivery/deliveryList'
// import deliveryConfig from '@/page/delivery/config'
import deliveryFastIn from '@/page/delivery/fastIn'
import newCustomer from '@/page/delivery/newCustomer'

// 中心仓库
import distributionList from '@/page/distribution/list'
import distributionOrder from '@/page/distribution/order'
import distributionFastIn from '@/page/distribution/fastInStorage'
import outStorage from '@/page/distribution/outStorage'



// 充值
import rechargeAccount from '@/page/recharge/account'
import rechargeFlows from '@/page/recharge/flows'
import rechargeCharge from '@/page/recharge/charge'
import rechargeAdjust from '@/page/recharge/adjust'
import rechargeRate from '@/page/recharge/rate'

//合箱
import BoxOrderList from '@/page/order/boxOrderList'

import Demo from '@/page/demo.vue'
import Face from '@/page/face.vue'

Vue.use(Router)


const routes = [

	{path: '/404', name: 'page404', component: Page404 },
	{
		path:'/',
		name:'登录',
		component:Login,
		meta: {
			title: '后台系统-登录',
			navHidden:true
		  }
	},
	{
		path:'/face',
		name:'面单',
		component:Face,
		meta: {
			title: '面单',
			navHidden:true
		  }
	},
	{
		path: '/',
		name: '订单列表',
		component: require('layout/home.vue'),
		redirect: '/orderList',
		children: [{
			path: '/orderList',
			name: '订单列表',
			component: orderList,
		},
		{
			path: '/addOrder',
			name: '创建订单',
			component: addOrder,
		},
		{
			path: '/dispathchList',
			name: '发货单',
			component: dispathchList,
		},{
			path: '/demo',
			name: '发货单',
			component: Demo,
		  },{
			path: '/order/box',
			name: '合箱列表',
			component: BoxOrderList,
		  }
		]
	},
	{
		path: '/',
		name: '货运',
		component: require('layout/home.vue'),
		redirect: '/priceContort',
		children: [
			{
			path: '/priceContort',
			name: '价格管理',
			component: priceContort,
		},
		{
			path: '/houserAddress',
			name: '仓库地址',
			component: houserAddress,
		},
		{
			path: '/priceGoods',
			name: '货物价格',
			component: priceGoods,
		},{
			path: '/checkExpress',
			name: '快递收货',
			component: checkExpress,
		 },{
			path: '/transport/list',
			name: '货运管理',
			component: transportList,
		 }
		]
	},
	{
		path: '/',
		name: '库存',
		component: require('layout/home.vue'),
		redirect: '/repertoryList',
		children: [{
			path: '/repertoryList',
			name: '库存列表',
			component: repertoryList,
		},
		{
			path: '/goOutList',
			name: '出入记录',
			component: goOutList,
		},
		]
	},{
		path: '/',
		name: '派送',
		component: require('layout/home.vue'),
		redirect: '/delivery/list',
		children: [{
			path: '/delivery/list',
			name: '地址配置',
			component: deliveryList,
		  },{
			path: '/delivery/order',
			name: '物流管理',
			component: deliveryOrder,
		  },{
			path: '/delivery/order/list',
			name: '订单管理',
			component: deliveryOrderList,
		  }
		  // Commented out unused appointment features
		  // ,{
		  //	path: '/delivery/book',
		  //	name: '预约订单',
		  //	component: deliveryBook,
		  // }
		  ,
		  {
			  path: '/delivery/deliveryList',
			  name: '派送列表',
			  component: deliveryForm,
		  },
		  // {
		  //	path: '/delivery/config',
		  //	name: '预约配置',
		  //	component: deliveryConfig,
		  // },
		  {
			  path: '/delivery/fastIn',
			  name: '扫码入库',
			  component: deliveryFastIn,
			},
			{
				path: '/delivery/fastIn',
				name: '扫码入库',
				component: deliveryFastIn,
			  },
			  {
				path: '/delivery/dispathchList',
				name: '发货单',
				component: deliverDispathchList,
			},
			{
				path: '/delivery/newCustomer',
				name: '客户列表',
				component: newCustomer,
			}
			
			
		]
	},{
		path: '/',
		name: '中心仓库',
		component: require('layout/home.vue'),
		redirect: '/distribution/list',
		children: [{
			path: '/distribution/list',
			name: '中心仓库管理',
			component: distributionList,
		  },{
			path: '/distribution/order',
			name: '物流管理',
			component: distributionOrder,
		  },{
			path: '/distribution/fastInStorage',
			name: '扫码入库',
			component: distributionFastIn,
			},
			{
				path: '/distribution/outStorage',
				name: '扫码出库',
				component: outStorage,
			},
		]
	},
	{
		path: '/',
		name: '充值',
		component: require('layout/home.vue'),
		redirect: '/recharge/account',
		children: [{
			path: '/recharge/account',
			name: '财务账号',
			component: rechargeAccount,
		  },
		  {
			path: '/recharge/Flows',
			name: '财务流动',
			component: rechargeFlows,
		  },
		  {
			path: '/recharge/Charge',
			name: '充值',
			component: rechargeCharge,
		  },
		  {
			path: '/recharge/Adjust',
			name: '调账',
			component: rechargeAdjust,
		  },
		  {
			path: '/recharge/rate',
			name: '汇率',
			component: rechargeRate,
		  }
		]
	},
	{
		path: '/',
		name: '设置',
		component: require('layout/home.vue'),
		redirect: '/system/agree',
		children: [{
			path: '/system/agree',
			name: '协议条款',
			component: Agree,
		  },
		  {
			path: '/system/notice',
			name: '首页公告',
			component: Notice,
		  }
		]
	},
	{
		path: '/',
		name: '人员',
		component: require('layout/home.vue'),
		redirect: '/adminList',
		children: [{
			path: '/adminList',
			name: '员工列表',
			component: adminList,
		},
		{
			path: '/customerList',
			name: '客户列表',
			component: customerList,
		},
		{
			path: '/announcement',
			name: '通知公告',
			component: require("../page/personnel/announcement.vue"),
		},
		{
			path: '/announcement/newOrEdit',
			name: '通知公告',
			component: require("../page/personnel/addEditComponent.vue"),
		},
		]
	},
	{
		path: '/',
		name: '工单',
		component: require('layout/home.vue'),
		redirect: '/workOrderList',
		children: [{
			path: '/workOrderList',
			name: '工单列表',
			component: workOrderList,
		},
		{
			path: '/workOrderRemark',
			name: '工单须知',
			component: workOrderRemark,
		},
		]
	},
	{
		path: '/',
		name: '统计',
		component: require('layout/home.vue'),
		redirect: '/statistical/runningWater',
		children: [
			{
				path: '/statistical/wayBill',
				name: '运单',
				component: require("../page/statistical/wayBill.vue"),
			  },
			  {
				path: '/statistical/cost',
				name: '费用',
				component: require("../page/statistical/cost.vue"),
			  },
		]
	},		
						
]

export default new Router({
	routes,
	strict: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/router/index.js